import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Leaf } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

export const NAV = [
  { to: "/products", label: "Products", id: "products" },
  { to: "/quality-compliance", label: "Quality & Compliance", id: "quality" },
  { to: "/about", label: "About", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors hover:text-emerald-900 ${isActive ? "text-emerald-900" : "text-stone-600"}`;

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
    <span className="h-9 w-9 rounded-md bg-emerald-900 text-emerald-50 grid place-items-center transition-transform group-hover:rotate-6">
      <Leaf className="h-5 w-5" />
    </span>
    <span className={`font-display font-semibold text-lg tracking-tight ${light ? "text-white" : "text-stone-900"}`}>
      SLN Agro Exports
    </span>
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between gap-6">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`nav-link-${n.id}`}>{n.label}</NavLink>
          ))}
          <Link to="/request-quote" data-testid="nav-quote-btn"
            className="rounded-full bg-amber-700 hover:bg-amber-800 text-white text-sm font-medium px-5 py-2.5 transition-colors">
            Request a quote
          </Link>
        </nav>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger className="md:hidden p-2 -mr-2" data-testid="nav-mobile-menu-btn" aria-label="Open menu">
            <Menu className="h-6 w-6" />
          </SheetTrigger>
          <SheetContent side="right" className="w-72">
            <SheetTitle className="font-display">Menu</SheetTitle>
            <div className="mt-8 flex flex-col gap-6">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} className={linkCls} onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${n.id}`}>{n.label}</NavLink>
              ))}
              <Link to="/request-quote" onClick={() => setOpen(false)} data-testid="mobile-nav-quote-btn"
                className="rounded-full bg-amber-700 text-white text-sm font-medium px-5 py-3 text-center">
                Request a quote
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
